import { ElNotification } from "element-plus";

export function showErrorMessage(error: Error, customTitle?: string) {
	let message = '';
	if ('servicestack' in error && Array.isArray(error.servicestack)) {
		error.servicestack.forEach(s => {
			message += `${s.service}: ${s.message}<br/>`;
		})
	} else {
		message += error.message+'<br/>';
	}
	if ('code' in error && error.code) message += `<br/>Code: ${error.code}`;
	if ('reqId' in error) message += `<p style="font-size:80%">[${error.reqId}]</p>`;

	ElNotification({
		type: 'error',
		title: customTitle,
		dangerouslyUseHTMLString: true,
		message,
		duration: 0
	});
}